<template>
  <div ref="recipient"
    class="w-full h-4 rounded-xl overflow-hidden  bg-gray-200">
    <div ref="gauge" class="transition-all delay-1000 h-full bg-green-500"></div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, watch, ref } from 'vue'
const props = defineProps<{
  filling: number
}>()

const recipient = ref<HTMLElement>()
const gauge = ref<HTMLElement>()

watch(() => props.filling, (newVal: number) => {
  setGaugeWidth(newVal)
})

const setGaugeWidth = (newVal: number) => {
  if (!gauge.value || !recipient.value) return

  // Handle 0/0 case or invalid values - show empty gauge
  if (!newVal || isNaN(newVal) || !isFinite(newVal)) {
    gauge.value.style.width = '0px'
    return
  }

  // Get the width representing the filling from the percentage that is newVal
  const fullWidth = recipient.value.clientWidth
  const fillingWidth = fullWidth * newVal / 100
  gauge.value.style.width = `${fillingWidth}px`
}

onMounted(() => {
  setGaugeWidth(0)
  setGaugeWidth(props.filling)
})
</script>